// extracted by mini-css-extract-plugin
export var connectionStatusErrorMessage = "connection-status__error-message_dcaIqUNcWaf7ZBxJMtus";
export var connectionStatusStatusTitle = "connection-status__status-title_KRFzD76fUfmVu3uEAi4_";
export var connectionStatusSuccessMessage = "connection-status__success-message_mQ6rFG_gObVi0UEuNlj9";